import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Tenants } from "./Tenants.js";
import { AdminStatus } from "./AdminStatus.js";
import { AdminHubUsers } from "./AdminHubUsers.js";
import { AdminTenantDetails } from "./AdminTenantDetails.js";
import { AdminAiAdmin } from "./AdminAiAdmin.js";
import { AdminTenantAiUsagePage } from "./AdminTenantAiUsagePage.js";
import { AdminBreakGlass } from "./AdminBreakGlass.js";
import { AdminAccount } from "./AdminAccount.js";
import { AdminSecrets } from "./AdminSecrets.js";
import { AdminHubConfig } from "./AdminHubConfig.js";
import { AdminBackup } from "./AdminBackup.js";
import { AdminPlatformKnowledge, AdminPlatformKnowledgeEditor } from "./AdminPlatformKnowledge.js";
import { AdminLearning } from "./AdminLearning.js";
import { AdminFeedback } from "./AdminFeedback.js";
import { apiFetch } from "../lib/api.js";
import { useEffect, useState } from "react";
import { AppShell } from "../components/AppShell.js";

export function AdminHome() {
  const nav = useNavigate();
  const [ready, setReady] = useState(false);
  const [userEmail, setUserEmail] = useState<string | undefined>(undefined);

  useEffect(() => {
    (async () => {
      try {
        const me = (await apiFetch("/api/auth/me")) as { user?: { email?: string } };
        setUserEmail(me.user?.email);
        setReady(true);
      } catch {
        nav("/login");
      }
    })();
  }, [nav]);

  if (!ready) {
    return (
      <div className="card">
        <div className="muted">Loading…</div>
      </div>
    );
  }

  return (
    <AppShell
      contextLabel="Operator"
      userEmail={userEmail}
      navItems={[
        { to: "/admin/status", label: "System Health" },
        { to: "/admin/tenants", label: "Tenants" },
        { to: "/admin/ai", label: "AI Admin" },
        { to: "/admin/platform-knowledge", label: "Platform Knowledge" },
        { to: "/admin/learning", label: "Learning" },
        { to: "/admin/feedback", label: "Feedback" },
        { to: "/admin/users", label: "Users" },
        { to: "/admin/secrets", label: "Atlas Vault" },
        { to: "/admin/hub-config", label: "Hub Config" },
        { to: "/admin/backup", label: "Backup" },
        { to: "/admin/break-glass", label: "Break-glass" }
      ]}
    >
      <Routes>
        <Route path="/" element={<Navigate to="/admin/status" replace />} />
        <Route path="/status" element={<AdminStatus />} />
        <Route path="/users" element={<AdminHubUsers />} />
        <Route path="/secrets" element={<AdminSecrets />} />
        <Route path="/hub-config" element={<AdminHubConfig />} />
        <Route path="/backup" element={<AdminBackup />} />
        <Route path="/break-glass" element={<AdminBreakGlass />} />
        <Route path="/tenants" element={<Tenants />} />
        <Route path="/ai" element={<AdminAiAdmin />} />
        {/* ADR-0148: legacy AI Knowledge page retired — Platform Knowledge is the single hub surface. */}
        <Route path="/ai-knowledge" element={<Navigate to="/admin/platform-knowledge" replace />} />
        <Route path="/platform-knowledge" element={<AdminPlatformKnowledge />} />
        <Route path="/platform-knowledge/new" element={<AdminPlatformKnowledgeEditor />} />
        <Route path="/platform-knowledge/entry/:name" element={<AdminPlatformKnowledgeEditor />} />
        <Route path="/learning" element={<AdminLearning />} />
        <Route path="/feedback" element={<AdminFeedback />} />
        <Route path="/ai-usage" element={<Navigate to="/admin/ai" replace />} />
        <Route path="/ai-models" element={<Navigate to="/admin/ai" replace />} />
        <Route path="/account" element={<AdminAccount />} />
        <Route path="/tenants/:tenantId/ai-usage" element={<AdminTenantAiUsagePage />} />
        <Route path="/tenants/:tenantId" element={<AdminTenantDetails />} />
      </Routes>
    </AppShell>
  );
}

